/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validatePlayIntegrityAttestation} from '../api'

export const useMutationValidatePlayIntegrityAttestation = createReactQueryMutationHook('validatePlayIntegrityAttestation', validatePlayIntegrityAttestation)
